export class TaminServiceReturnModel{
    constructor() {
        this.succeeded=false;
    }

    public taminToken?:string;
    public succeeded:boolean;
    public message?:string;
}